import React from 'react'

function BingAdsAlerts() {
  return (
    <div className="bg-white p-6 m-4 rounded-md   mb-16">
      <div className="flex justify-between py-4">
        <h1 className="text-2xl text-gray-600 font-semibold ">
          Bing Ads Alerts
        </h1>
      </div>
    </div>
  )
}

export default BingAdsAlerts
